import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link
              to={item.to}
              className="text-foreground-500 transition-colors hover:text-primary-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
          {i < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          )}
        </span>
      ))}
    </nav>
  );
}